/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Create_Ad_Template_PendingInputs */



/**
* | output |
* | --- |
* | "Creating AD template... please wait..." |
*
* @param {Event_Group_Options_Create_Ad_Template_PendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_create_ad_template_pending = /** @type {((inputs?: Event_Group_Options_Create_Ad_Template_PendingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Create_Ad_Template_PendingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Création du modèle de description audio... veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Vorlage wird erstellt... Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione del modello di annuncio... attendere prego...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание шаблона объявления... пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando plantilla de AD... por favor espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在创建广告模板……请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AD テンプレートを作成しています...お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD टेम्प्लेट बनाया जा रहा है... कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criando modelo de anúncio... aguarde...")
	return /** @type {LocalizedString} */ ("Creating AD template... please wait...")
});